import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetQuotesQuery, useUpdateQuoteMutation ,selectAllQuotes} from './quotesApiSlice';


const EditQuote = () => {
  const { id } = useParams();
  const quotes = useSelector(selectAllQuotes); // ✅ selector returns array
  const quote = quotes.find(q => q._id === id);
  const [formData, setFormData] = useState({ text: '', author: '', category: '', language: 'hi' });
  const [updateQuote] = useUpdateQuoteMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (quote) setFormData(quote);
  }, [quote]);

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    await updateQuote({ id, ...formData });
    navigate('/dashboard/quotes');
  };

  return (
    <div>
      <h2>Edit Quote</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" name="text" value={formData.text} onChange={handleChange} /><br />
        <input type="text" name="author" value={formData.author} onChange={handleChange} /><br />
        <input type="text" name="category" value={formData.category} onChange={handleChange} /><br />
        <select name="language" value={formData.language} onChange={handleChange}>
          <option value="hi">Hindi</option>
          <option value="en">English</option>
        </select><br />
        <button type="submit">Update</button>
      </form>
    </div>
  );
};

export default EditQuote;